import React from "react";
import ReactDOM from "react-dom/client";
import {QueryClient, QueryClientProvider} from "react-query";
import {BrowserRouter, Route, Routes} from "react-router-dom";
import {ProtectedRoute} from "./routes/ProtectedRoute";

import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/administrator/DashboardPage";
import {StoresPage} from "./pages/administrator/management/StoresPage";
import UsersPage from "./pages/administrator/management/UsersPage";
import SingleStorePage from "./pages/administrator/SingleStorePage";
import AnalysisPage from "./pages/administrator/calculation/AnalysisPage";
import ManageUserStoresPage from "./pages/administrator/ManageUserStoresPage";
import AcquisitionPage from "./pages/administrator/calculation/AcquisitionPage";
import ForecastPage from "./pages/administrator/calculation/ForecastPage";
import UserProfile from "./pages/administrator/menu/UserProfile";
import SettingsPage from "./pages/administrator/menu/SettingsPage";
import SupplierPage from "./pages/administrator/management/SupplierPage";
import LogsPage from "./pages/administrator/LogsPage";
import AbcVedPage from "./pages/administrator/calculation/AbcVedPage";
import AdministratorRoute from "./routes/AdministratorRoute";
import CreateUserPage from "./pages/administrator/management/CreateUserPage";
import ProductsByStorePage from "./pages/administrator/management/ProductsByStorePage";
import LagerByStorePage from "./pages/administrator/management/LagerByStorePage";

import {LanguageProvider} from "./components/LanguageContext";
import HistoryByStorePage from "./pages/administrator/management/HistoryByStorePage";
import OrdersByStorePage from "./pages/administrator/orders/OrdersByStorePage";
import OrdersByCalculationPage from "./pages/administrator/orders/OrdersByCalculationPage";
import OrderInfoPage from "./pages/administrator/orders/OrderInfoPage";
import ReportsPage from "./pages/administrator/ReportsPage";

const ApplicationRoutes = () => {
    return (
        <BrowserRouter>
            <Routes>
                <Route path="" index exact element={<LoginPage/>}/>

                <Route path="/*" element={<ProtectedRoute/>}>
                    <Route path="" element={<AdministratorRoute/>}>
                        <Route path="pocetna" element={<DashboardPage/>}/>
                        <Route path="prodavnice" element={<StoresPage/>}/>

                        <Route path="prodavnica/:storeCode" element={<SingleStorePage/>}/>
                        <Route path="prodavnica/:storeCode/proizvodi" element={<ProductsByStorePage/>}/>
                        <Route path="prodavnica/:storeCode/lager" element={<LagerByStorePage/>}/>
                        <Route path="prodavnica/:storeCode/istorijat" element={<HistoryByStorePage/>}/>
                        <Route path="prodavnica/:storeId/informacije/:excelId" element={<ForecastPage/>}/>
                        <Route path="prodavnica/:storeId/informacije/:excelId/analiza" exact element={<AnalysisPage/>}/>
                        <Route path="prodavnica/:storeId/informacije/:excelId/abc-ved" exact element={<AbcVedPage/>}/>
                        <Route path="prodavnica/:storeId/informacije/:excelId/nabavka" exact
                               element={<AcquisitionPage/>}/>

                        <Route path="prodavnica/:storeCode/izvestaji" exact
                               element={<ReportsPage/>}/>

                        <Route path="prodavnica/:storeId/informacije/:excelId/narudzbine" exact
                               element={<OrdersByCalculationPage/>}/>
                        <Route path="prodavnica/:storeId/narudzbine" exact
                               element={<OrdersByStorePage/>}/>
                        <Route path="narudzbina/:id" exact
                               element={<OrderInfoPage/>}/>

                        <Route path="dobavljaci" exact element={<SupplierPage/>}/>
                        <Route path="korisnici" exact element={<UsersPage/>}/>
                        <Route path="profil/:userId" exact element={<UserProfile/>}/>
                        <Route path="podešavanja" exact element={<SettingsPage/>}/>
                        <Route path="obavestenja" exact element={<LogsPage/>}/>

                        <Route path="korisnik/:userId" exact element={<ManageUserStoresPage/>}/>
                        <Route path="novi-korisnik" exact element={<CreateUserPage/>}/>
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    );
};

function App() {
    const queryClient = new QueryClient();
    return (
        <QueryClientProvider client={queryClient}>
            <LanguageProvider>
                <ApplicationRoutes></ApplicationRoutes>
            </LanguageProvider>
        </QueryClientProvider>

    );
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App/>);
